// Extracted for unit/a11y testing. The slim banner shown above the voting UI
// for an anonymous guest: states the "voting as guest" context and surfaces the
// sign-in / "make an account" affordance. Presentational only — the auth action
// is passed in (`onSignIn`).
export default function VotingAsGuestBanner({ onSignIn }) {
  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-brand-primary/30 bg-brand-primary/10 px-4 py-3 text-sm"
    >
      <p className="font-semibold text-brand-primary dark:text-brand-primary">
        Voting as guest
      </p>
      <button
        type="button"
        onClick={onSignIn}
        className="min-h-[40px] rounded-full bg-brand-primary px-4 py-1.5 text-sm font-semibold text-white transition-colors hover:bg-brand-primary/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2"
      >
        Make an account for free
      </button>
    </div>
  );
}
